const random = Math.random();

export const WORLD_SIZE = 128;
export const FLAG_CAPTURE_DISTANCE = 3;
export const JUMP_POWER = random < 0.5 ? 18 : 5; // 6
export const SUPER_JUMP_POWER = 18;
export const MOVE_SPEED = random >= 0.5 ? 50 : 15; // 20
export const SUPER_MOVE_SPEED = 100;
